(function(){
'use strict';

const BL=['F','F\u266f','G','G\u266f','A','A\u266f','B','C','C\u266f','D','D\u266f','E'];
const BS=[5,6,7,8,9,10,11,0,1,2,3,4];
const CN=['C','C\u266f','D','D\u266f','E','F','F\u266f','G','G\u266f','A','A\u266f','B'];
const CP=['C','C#','D','D#','E','F','F#','G','G#','A','A#','B'];
const TS={
  'Equal Temperament':[0,0,0,0,0,0,0,0,0,0,0,0],
  'Just Intonation':[0,11.7,3.9,-15.6,-13.7,-2,-9.8,2,-13.7,-15.6,17.6,-11.7],
  'Pythagorean':[0,13.7,3.9,-9.8,7.8,-2,11.7,2,15.6,5.9,-7.8,9.8]
};

// Disc colors (parity with the app's Appearance picker). Each is a separate
// product photo on the Shopify CDN; selecting one swaps the disc image src.
const DISC={
  wood:'https://cdn.shopify.com/s/files/1/0740/9657/4706/files/cyber-tone-wood-electronic-pitch-pipe-front-view.png?v=1765518771',
  orange:'https://cdn.shopify.com/s/files/1/0740/9657/4706/files/cyber-tone-orange-electronic-pitch-pipe-front-view.png?v=1765518771',
  purple:'https://cdn.shopify.com/s/files/1/0740/9657/4706/files/cyber-tone-purple-electronic-pitch-pipe-front-view.png?v=1765518771',
  green:'https://cdn.shopify.com/s/files/1/0740/9657/4706/files/cyber-tone-green-electronic-pitch-pipe-front-view.png?v=1765518771',
  pink:'https://cdn.shopify.com/s/files/1/0740/9657/4706/files/cyber-tone-pink-electronic-pitch-pipe-front-view.png?v=1772906040',
  red:'https://cdn.shopify.com/s/files/1/0740/9657/4706/files/cyber-tone-red-electronic-pitch-pipe-front-view.png?v=1765518771',
  blue:'https://cdn.shopify.com/s/files/1/0740/9657/4706/files/cyber-tone-blue-electronic-pitch-pipe-front-view.png?v=1765518771'
};
// Swatch order/labels match the app; .c is the dot color shown in the picker.
const DISC_SW=[
  {k:'wood',n:'Wood',c:'linear-gradient(135deg,#b88a5a,#7a5230)'},
  {k:'orange',n:'Orange',c:'#FF8A00'},
  {k:'purple',n:'Purple',c:'#8b5cf6'},
  {k:'green',n:'Green',c:'#3fae5a'},
  {k:'pink',n:'Pink',c:'#ec4899'},
  {k:'red',n:'Red',c:'#e23b3b'},
  {k:'blue',n:'Blue',c:'#3b82f6'}
];

let S={lowestMIDI:65,tunSys:'Equal Temperament',tunRoot:0,
  rn:'A',ro:4,rf:440,bpm:100,mOn:false,mMidi:69,susOn:false,color:'wood',
  perf:false,mask:0x0FFF,offsets:{}};
let pressed=new Set(),sticky=new Set(),taps={};
let osc={},mRun=false,mBeat=0,mNext=0,mTid=null;
let ntSelected=null;
let ac=null;
let touchBtn={},mouseBtn=null,inputReady=false;

function save(){try{localStorage.setItem('ct3',JSON.stringify(S));}catch(e){}}
function load(){try{let s=JSON.parse(localStorage.getItem('ct3'));if(s)Object.assign(S,s);}catch(e){}
  if(!(S.tunSys in TS))S.tunSys='Equal Temperament';}

function ea(){
  if(!ac){
    try{ac=new(window.AudioContext||window.webkitAudioContext)({latencyHint:'interactive'});}catch(e){try{ac=new(window.AudioContext||window.webkitAudioContext)();}catch(e2){return null;}}
  }
 if(ac.state==='suspended'||ac.state==='interrupted'){ ac.resume().catch(function(){}); }
  return ac;
}

// --- iOS silent-switch bypass -------------------------------------------------
// iOS mutes Web Audio when the physical ringer/silent switch is on. Playing a
// near-silent looping <audio> element flips the iOS audio session to the
// "playback" category, after which our oscillator tones sound even on silent.
// Gated to iOS only; auto-pauses ~4s after the last note so it does not linger
// as "Now Playing". (Same approach used by Howler.js / Tone.js.)
var ctSilentEl=null, ctSilentTimer=null;
var CT_SILENT_SRC="data:audio/wav;base64,UklGRiQZAABXQVZFZm10IBAAAAABAAEAQB8AAIA+AAACABAAZGF0YQAZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA";
function ctIsIOS(){
  return /iP(hone|ad|od)/.test(navigator.userAgent) ||
         (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints>1);
}
function ctSilentOff(){ if(ctSilentEl){ try{ctSilentEl.pause();}catch(e){} } }
function ctSilentOn(){
  if(!ctIsIOS())return;
  if(!ctSilentEl){
    try{
      ctSilentEl=document.createElement('audio');
      ctSilentEl.loop=true; ctSilentEl.preload='auto'; ctSilentEl.volume=0.03;
      ctSilentEl.setAttribute('playsinline','');
      ctSilentEl.setAttribute('webkit-playsinline','');
      ctSilentEl.src=CT_SILENT_SRC;
      ctSilentEl.style.cssText='position:absolute;width:0;height:0;opacity:0;pointer-events:none';
      (document.body||document.documentElement).appendChild(ctSilentEl);
    }catch(e){ return; }
  }
  try{ var p=ctSilentEl.play(); if(p&&p.catch)p.catch(function(){}); }catch(e){}
  if(ctSilentTimer)clearTimeout(ctSilentTimer);
  ctSilentTimer=setTimeout(ctSilentOff,4000);
}
// -----------------------------------------------------------------------------

function freq(m){
  let rm=CP.indexOf(S.rn)+12*(S.ro+1);
  let c=S.offsets[m]||0;
  return S.rf*Math.pow(2,(m-rm)/12)*Math.pow(2,c/1200);
}

function nn(m){let p=((m%12)+12)%12;return CN[p]+(Math.floor(m/12)-1)}

function m4b(i){
  let ls=S.lowestMIDI%12,lo=S.lowestMIDI-ls,bs=BS[i],m=lo+bs;
  if(m<S.lowestMIDI)m+=12;return m;
}

function play(vi,mid){
  let ctx=ea();if(!ctx)return;
  ctSilentOn();
  // Safari/iOS: if the context isn't running yet, prime a silent buffer and
  // resume, all SYNCHRONOUSLY inside this user gesture. iOS blocks audio that
  // is started from an async callback (promise/timeout), so we must NOT defer
  // the oscillator. We start it now; it sounds the instant the context resumes
  // (resume was requested in this same gesture). Chrome handles this fine too.
  if(ctx.state!=='running'){
    try{let b=ctx.createBuffer(1,1,22050),s=ctx.createBufferSource();s.buffer=b;s.connect(ctx.destination);s.start(0);}catch(e){}
    try{ctx.resume();}catch(e){}
  }
  stop(vi);
  let f=freq(mid);
  let o=ctx.createOscillator(),g=ctx.createGain();
  o.type='square';o.frequency.value=f;
  let t=ctx.currentTime;
  g.gain.setValueAtTime(0.0001,t);
  g.gain.linearRampToValueAtTime(0.6,t+0.006);
  o.connect(g);g.connect(ctx.destination);
  o.start(t);
  osc[vi]={o,g,mid};
}

function stop(vi){
  let x=osc[vi];if(!x)return;
  if(!ac){delete osc[vi];return;}
  try{
    let t=ac.currentTime;
    x.g.gain.cancelScheduledValues(t);
    x.g.gain.setValueAtTime(x.g.gain.value,t);
    x.g.gain.linearRampToValueAtTime(0,t+0.02);
    setTimeout(()=>{try{x.o.stop();}catch(e){}},30);
  }catch(e){}
  delete osc[vi];
}

function stopAll(){for(let k in osc)stop(+k);}

function q(id){return document.getElementById(id);}

// Geometry shared by the highlight markers and the hit-testing below.
const DISC_STEP=360/13, DISC_START=-90+DISC_STEP, DISC_R=44;

function mkBtns(){
  let c=q('pp-dw');
  c.querySelectorAll('.pp-nbtn').forEach(b=>b.remove());
  // The 12 circles are now display-only highlight markers, all input is
  // handled by a single full-disc surface (see setupDiscInput) that maps a
  // touch to the nearest note and lets you slide between notes, mirroring
  // the iOS app. pointer-events:none keeps them from capturing touches.
  for(let i=0;i<12;i++){
    let b=document.createElement('div');
    b.className='pp-nbtn';
    b.dataset.i=i;
    let a=(DISC_START+i*DISC_STEP)*Math.PI/180;
    b.style.cssText=
      'position:absolute;width:17%;height:17%;border-radius:50%;'+
      'background:rgba(255,255,255,0.005);pointer-events:none;'+
      'transform:translate(-50%,-50%);z-index:10;'+
      'transition:background .08s,box-shadow .08s;'+
      'left:'+(50+DISC_R*Math.cos(a))+'%;top:'+(50+DISC_R*Math.sin(a))+'%;';
    c.appendChild(b);
  }
  setupDiscInput();
  ub();
}

// Nearest playable button (1..12) to a client-space point, or null.
// Whole disc is partitioned by nearest note (like the app), so there are
// no dead gaps and the effective target for each note is large.
function nearestBtn(cx,cy){
  let dw=q('pp-dw');if(!dw)return null;
  let r=dw.getBoundingClientRect();if(!r.width)return null;
  let sz=r.width,mid=sz/2,R=sz*DISC_R/100;
  let px=cx-r.left,py=cy-r.top;
  let best=null,bestD=Infinity;
  for(let i=0;i<12;i++){
    if(S.perf&&!(S.mask&(1<<i)))continue;        // skip masked-off notes
    let a=(DISC_START+i*DISC_STEP)*Math.PI/180;
    let bx=mid+R*Math.cos(a),by=mid+R*Math.sin(a);
    let dx=px-bx,dy=py-by,d=dx*dx+dy*dy;
    if(d<bestD){bestD=d;best=i+1;}
  }
  return best;
}

// Is (x,y) inside the disc, and are we free to play (settings closed)?
function inDisc(x,y){
  let s=q('pp-sov');if(s&&s.classList.contains('open'))return false;
  let dw=q('pp-dw');if(!dw)return false;
  let r=dw.getBoundingClientRect();if(!r.width)return false;
  return x>=r.left&&x<=r.right&&y>=r.top&&y<=r.bottom;
}

// Full-disc input. Listeners live on `document` (which reliably receives
// touch/pointer events on iOS, regardless of element hit-testing) and we
// decide by geometry: a touch inside the disc maps to the NEAREST note, so
// the whole disc is live (large targets) and sliding a finger releases the
// old note and presses the new one, mirroring the iOS app. Only touches
// that START on the disc are tracked, so the rest of the page is untouched.
function setupDiscInput(){
  if(inputReady)return;inputReady=true;

  document.addEventListener('touchstart',function(e){
    for(let k=0;k<e.changedTouches.length;k++){
      let t=e.changedTouches[k];
      if(!inDisc(t.clientX,t.clientY))continue;
      e.preventDefault();
      let bt=nearestBtn(t.clientX,t.clientY);
      touchBtn[t.identifier]=bt;
      if(bt)hp(bt,false);
    }
  },{passive:false});
  document.addEventListener('touchmove',function(e){
    for(let k=0;k<e.changedTouches.length;k++){
      let t=e.changedTouches[k];
      if(!(t.identifier in touchBtn))continue;
      e.preventDefault();
      let prev=touchBtn[t.identifier],bt=nearestBtn(t.clientX,t.clientY);
      if(bt!==prev){if(prev)hr(prev);if(bt)hp(bt,true);touchBtn[t.identifier]=bt;}
    }
  },{passive:false});
  function endTouch(e){
    for(let k=0;k<e.changedTouches.length;k++){
      let t=e.changedTouches[k];
      if(!(t.identifier in touchBtn))continue;
      if(touchBtn[t.identifier])hr(touchBtn[t.identifier]);
      delete touchBtn[t.identifier];
    }
  }
  document.addEventListener('touchend',endTouch,{passive:false});
  document.addEventListener('touchcancel',endTouch,{passive:false});

  // Mouse (and pen) via pointer events, single-pointer slide.
  document.addEventListener('pointerdown',function(e){
    if(e.pointerType==='touch'||!inDisc(e.clientX,e.clientY))return;
    e.preventDefault();
    mouseBtn=nearestBtn(e.clientX,e.clientY);
    if(mouseBtn)hp(mouseBtn,false);
  });
  document.addEventListener('pointermove',function(e){
    if(e.pointerType==='touch'||mouseBtn===null||!(e.buttons&1))return;
    let bt=nearestBtn(e.clientX,e.clientY);
    if(bt!==mouseBtn){if(mouseBtn)hr(mouseBtn);if(bt)hp(bt,true);mouseBtn=bt;}
  });
  function endMouse(e){
    if(e.pointerType==='touch'||mouseBtn===null)return;
    hr(mouseBtn);mouseBtn=null;
  }
  document.addEventListener('pointerup',endMouse);
  document.addEventListener('pointercancel',endMouse);
}

// slide=true when a finger/mouse slid ONTO this note (vs a fresh press):
// slides just play the note, they don't toggle sticky or count toward the
// 5-tap sticky gesture, which only makes sense for taps in place.
function hp(bt,slide){
  let mid=m4b(bt-1);
  if(S.mOn){S.mMidi=mid;sn(nn(mid));umk();return;}
  if(S.perf&&!(S.mask&(1<<(bt-1))))return;

  // Sustain mode (like the app): a tap latches the note; tapping a latched
  // note unlatches it. Sliding/dragging latches each note it crosses (build
  // a held chord). Latched notes keep sounding after release (hr skips them).
  if(S.susOn){
    if(!slide&&sticky.has(bt)){sticky.delete(bt);stop(bt-1);if(!pressed.size&&!sticky.size)hn();ub();return;}
    if(sticky.has(bt))return;
    sticky.add(bt);pressed.delete(bt);sn(nn(mid));play(bt-1,mid);ub();return;
  }

  if(!slide&&sticky.has(bt)){sticky.delete(bt);stop(bt-1);ub();return;}
  if(slide&&sticky.has(bt))return;          // already sounding via sticky
  pressed.add(bt);sn(nn(mid));play(bt-1,mid);
  if(!slide){
    let now=Date.now();if(!taps[bt])taps[bt]=[];
    taps[bt].push(now);taps[bt]=taps[bt].filter(t=>now-t<=2000);
    if(taps[bt].length>=5){sticky.add(bt);pressed.delete(bt);taps[bt]=[];}
  }
  ub();
}

function hr(bt){
  if(sticky.has(bt))return;
  pressed.delete(bt);
  if(!pressed.size&&!sticky.size)hn();
  if(!S.mOn)stop(bt-1);
  ub();
}

function ub(){
  document.querySelectorAll('.pp-nbtn').forEach(b=>{
    let i=+b.dataset.i,bt=i+1;
    let ok=!S.perf||(S.mask&(1<<i));
    if(pressed.has(bt)){b.style.background='rgba(254,165,0,0.55)';b.style.boxShadow='0 0 18px rgba(254,165,0,.55)';}
    else if(sticky.has(bt)){b.style.background='rgba(254,165,0,0.75)';b.style.boxShadow='0 0 18px rgba(254,165,0,.6)';}
    else{b.style.background='rgba(255,255,255,0.005)';b.style.boxShadow='none';}
    b.style.opacity=ok?'1':'0.3';
  });
}

function sn(s){let e=q('pp-nn');if(e)e.textContent=s;}
function hn(){let e=q('pp-nn');if(e)e.textContent='';}

function toast(m){
  let t=q('pp-toast');if(!t)return;
  t.textContent=m;t.classList.add('show');
  setTimeout(()=>t.classList.remove('show'),2000);
}

function togM(){
  S.mOn=!S.mOn;
  let sw=q('pp-msw');if(sw)sw.classList.toggle('on',S.mOn);
  let mx=q('pp-mx');if(mx)mx.classList.toggle('open',S.mOn);
  // Sustain and metronome are mutually visible (app parity): turning the
  // metronome on hides the sustain switch and clears any held notes.
  if(S.mOn&&S.susOn)setSustain(false);
  uSusVis();
  umk();umd();
  if(S.mOn)startM();else stopM();
  save();
}

// Sustain switch. setSustain(false) also releases every held note, matching
// the app (turning sustain off stops sustained playback).
function setSustain(on){
  S.susOn=on;
  let sw=q('pp-ssw');if(sw)sw.classList.toggle('on',on);
  if(!on){sticky.forEach(bt=>stop(bt-1));sticky.clear();if(!pressed.size)hn();ub();}
}
function togS(){setSustain(!S.susOn);save();}
function uSusVis(){let r=q('pp-sus-row');if(r)r.style.display=S.mOn?'none':'flex';}

// Inject the Sustain row next to the Metronome row (kept in JS so the page
// template needs no edit). Styled with the existing .pp-sw switch.
function buildSustainSwitch(){
  if(q('pp-sus-row'))return;
  let mt=document.querySelector('#ct-pp .mt-row');if(!mt)return;
  let row=document.createElement('div');
  row.className='mt-row';row.id='pp-sus-row';
  row.innerHTML='<label>Sustain</label>'+
    '<div class="pp-sw" id="pp-ssw"><div class="k"></div></div>';
  mt.insertAdjacentElement('afterend',row);
  let sw=q('pp-ssw');if(sw)sw.addEventListener('click',togS);
}

// Disc color picker (app parity). Swaps the disc photo's src.
function applyColor(){
  let img=document.querySelector('#pp-dw .dev-img');
  if(img&&DISC[S.color])img.src=DISC[S.color];
  let d=q('pp-d-color');if(d){let sw=DISC_SW.find(x=>x.k===S.color);d.textContent=sw?sw.n:'Wood';}
}
function setColor(k){if(!DISC[k])return;S.color=k;applyColor();rndColor();save();}
function rndColor(){
  let g=q('pp-cg');if(!g)return;g.innerHTML='';
  DISC_SW.forEach(sw=>{
    let b=document.createElement('div');b.title=sw.n;
    // display:inline-block is required: the Shopify theme's base-start.css
    // hides every empty <div> (`div:empty{display:none}`), and these swatch
    // dots have no text. An inline display overrides that non-!important rule.
    b.style.cssText='display:inline-block;width:34px;height:34px;border-radius:50%;cursor:pointer;background:'+sw.c+
      ';border:2px solid '+(S.color===sw.k?'#fff':'rgba(255,255,255,.15)')+
      ';box-shadow:'+(S.color===sw.k?'0 0 0 2px #FEA500':'none')+';';
    b.addEventListener('click',()=>setColor(sw.k));
    g.appendChild(b);
  });
}
// Inject an Appearance section into Settings (kept in JS so the page
// template needs no edit). Mirrors the existing collapsible .sec sections.
function buildColorSection(){
  if(q('pp-s-color'))return;
  let ssh=document.querySelector('#ct-pp .ssh');if(!ssh)return;
  let sec=document.createElement('div');
  sec.className='sec';sec.id='pp-s-color';
  sec.innerHTML=
    '<div class="sec-h"><span class="t">Appearance</span>'+
    '<div style="display:flex;align-items:center">'+
    '<span class="d" id="pp-d-color">Wood</span>'+
    '<span class="arr" id="pp-c-color">›</span></div></div>'+
    '<div class="sec-b" id="pp-b-color">'+
    '<div class="lb">Disc Color</div>'+
    '<div id="pp-cg" style="display:flex;flex-wrap:wrap;gap:12px;padding:4px 0"></div>'+
    '</div>';
  let secs=ssh.querySelectorAll('.sec'),last=secs[secs.length-1];
  if(last)last.insertAdjacentElement('afterend',sec);else ssh.appendChild(sec);
  sec.querySelector('.sec-h').addEventListener('click',()=>tog('color'));
  rndColor();
}

function startM(){
  let ctx=ea();if(!ctx)return;
  mRun=true;mBeat=0;mNext=ctx.currentTime;schB();
}
function stopM(){mRun=false;if(mTid){clearTimeout(mTid);mTid=null;}}

function schB(){
  if(!mRun||!ac)return;
  mNext+=60/S.bpm;
  let d=Math.max(0,(mNext-ac.currentTime)*1000);
  mTid=setTimeout(()=>{if(!mRun)return;fireB();schB();},d);
}

function fireB(){
  let ctx=ea();if(!ctx)return;
  let f=freq(S.mMidi);
  let o=ctx.createOscillator(),g=ctx.createGain();
  o.type='square';o.frequency.value=f;g.gain.value=0.6;
  o.connect(g);g.connect(ctx.destination);
  let t=ctx.currentTime;o.start(t);
  g.gain.linearRampToValueAtTime(0,t+0.03);o.stop(t+0.04);
  mBeat++;
}

function bpm(d){
  S.bpm=Math.max(20,Math.min(300,S.bpm+d));
  let e=q('pp-bn');if(e)e.textContent=S.bpm;
  umd();save();
}

function umk(){
  let e=q('pp-mk');if(e)e.textContent=nn(S.mMidi);
  let ns=q('pp-ns');if(ns)ns.textContent=S.mOn?'\u266a '+nn(S.mMidi):'';
}

function umd(){
  let e=q('pp-d-metro');if(e)e.textContent=S.mOn?S.bpm+' BPM':'Off';
}

let wo=0,wd=false,wl=0;
function initW(){
  let el=q('pp-tw'),cv=q('pp-wc');if(!el||!cv)return;
  cv.width=el.offsetWidth*2;cv.height=el.offsetHeight*2;
  (function draw(){
    let ctx=cv.getContext('2d'),w=cv.width,h=cv.height;
    ctx.clearRect(0,0,w,h);
    let sp=24,cx=w/2,cnt=Math.ceil(w/sp)+4;
    for(let i=-cnt/2;i<cnt/2;i++){
      let x=cx+i*sp+(wo*2)%sp;
      let gi=i-Math.round(wo*2/sp),mj=gi%5===0;
      let ds=Math.abs(x-cx)/(w/2),fd=Math.max(0,1-ds);
      ctx.fillStyle='rgba(254,165,0,'+(mj?fd*.9:fd*.45)+')';
      let nw=mj?4:2,nh=mj?h*.65:h*.35;
      ctx.fillRect(x-nw/2,(h-nh)/2,nw,nh);
    }
    requestAnimationFrame(draw);
  })();
  let acc=0;
  el.addEventListener('pointerdown',function(e){wd=true;wl=e.clientX;acc=0;el.setPointerCapture(e.pointerId);});
  el.addEventListener('pointermove',function(e){if(!wd)return;let dx=e.clientX-wl;wl=e.clientX;wo+=dx;acc-=dx/12;let d=Math.trunc(acc);if(d){acc-=d;bpm(d);}});
  el.addEventListener('pointerup',function(){wd=false;});
  el.addEventListener('pointercancel',function(){wd=false;});
}

function openS(){let e=q('pp-sov');if(e)e.classList.add('open');rndS();}
function closeS(){let e=q('pp-sov');if(e)e.classList.remove('open');stopAll();uAll();}

function tog(id){
  let b=q('pp-b-'+id),c=q('pp-c-'+id);
  if(!b||!c)return;let o=b.classList.toggle('op');c.classList.toggle('op',o);
}

function rndS(){
  if(q('pp-s-range'))q('pp-s-range').style.display='';
  if(q('pp-s-tuning'))q('pp-s-tuning').style.display='';
  if(q('pp-s-micro'))q('pp-s-micro').style.display='';
  if(q('pp-s-perf'))q('pp-s-perf').style.display='';
  uRange();rndTun();rndNT();rndPerf();rndColor();umd();
}

function rStr(){return nn(S.lowestMIDI)+' \u2013 '+nn(S.lowestMIDI+11);}
function uRange(){
  let s=rStr();
  ['pp-d-range','pp-rdv','pp-rnv'].forEach(id=>{let e=q(id);if(e)e.textContent=s;});
  let c4=q('pp-pC4'),f4=q('pp-pF4');
  if(c4)c4.classList.toggle('sel',S.lowestMIDI===60);
  if(f4)f4.classList.toggle('sel',S.lowestMIDI===65);
}
function nr(d){S.lowestMIDI=Math.max(60,Math.min(70,S.lowestMIDI+d));uRange();save();}
function sr(m){S.lowestMIDI=Math.max(60,Math.min(70,m));uRange();save();}

function rndTun(){
  let list=q('pp-tl');if(!list)return;list.innerHTML='';
  for(let nm in TS){
    let d=document.createElement('div');
    d.className='ti'+(S.tunSys===nm?' sel':'');
    d.innerHTML='<span class="n">'+nm+'</span>'+(S.tunSys===nm?'<span class="ck">\u2713</span>':'');
    d.onclick=()=>{S.tunSys=nm;rndTun();save();};
    list.appendChild(d);
  }
  let sr=S.tunSys!=='Equal Temperament';
  let rs=q('pp-rootSec');if(rs)rs.style.display=sr?'block':'none';
  if(sr){
    let g=q('pp-rootG');if(!g)return;g.innerHTML='';
    CP.forEach((n,i)=>{
      let b=document.createElement('button');b.textContent=n;
      b.className=i===S.tunRoot?'sel':'';
      b.onclick=()=>{S.tunRoot=i;rndTun();save();};
      g.appendChild(b);
    });
  }
  let sel=q('pp-rn');
  if(sel&&!sel.children.length)CP.forEach(n=>{
    let o=document.createElement('option');o.value=n;o.textContent=n;sel.appendChild(o);
  });
  if(sel)sel.value=S.rn;
  let oe=q('pp-ro');if(oe)oe.value=S.ro;
  let fe=q('pp-rf');if(fe)fe.value=S.rf;
  uRR();uTD();
}

function uRef(){
  S.rn=q('pp-rn').value;
  S.ro=parseInt(q('pp-ro').value)||4;
  S.rf=parseFloat(q('pp-rf').value)||440;
  uRR();save();
}

function uRR(){
  let m=CP.indexOf(S.rn)+12*(S.ro+1);
  let e=q('pp-rro');if(e)e.textContent=nn(m)+' = '+S.rf.toFixed(1)+' Hz';
  uTD();
}

function uTD(){
  let m=CP.indexOf(S.rn)+12*(S.ro+1);
  let e=q('pp-d-tuning');
  if(e)e.textContent=S.tunSys+' \u2014 '+nn(m)+' = '+S.rf.toFixed(1)+' Hz';
}

function applyT(){
  let base=TS[S.tunSys],ro=base[S.tunRoot];S.offsets={};
  for(let m=48;m<=95;m++){let pc=((m%12)+12)%12;S.offsets[m]=base[pc]-ro;}
  save();toast('Tuning applied');rndNT();
}

function rndNT(){
  let g=q('pp-nt-grid');if(!g)return;g.innerHTML='';
  for(let i=0;i<12;i++){
    let m=S.lowestMIDI+i,pc=((m%12)+12)%12,nm=CN[pc]+(Math.floor(m/12)-1);
    let c=S.offsets[m]||0,tuned=c!==0;
    let b=document.createElement('div');
    b.className='nt-cell'+(tuned?' tuned':'')+(ntSelected===m?' sel':'');
    b.innerHTML='<div class="nt-cell-name">'+nm+'</div><div class="nt-cell-cents">'+(c>=0?'+':'')+c+'\xa2</div>';
    b.onclick=()=>ntSelect(m);
    g.appendChild(b);
  }
}

function ntSelect(m){
  ntSelected=m;
  let pc=((m%12)+12)%12,nm=CN[pc]+(Math.floor(m/12)-1);
  let c=S.offsets[m]||0;
  let lbl=q('pp-nt-label');if(lbl)lbl.textContent=nm;
  let val=q('pp-nt-val');if(val)val.textContent=(c>=0?'+':'')+c+'\xa2';
  let sl=q('pp-nt-slider');if(sl)sl.value=c;
  let adj=q('pp-nt-adj');if(adj)adj.classList.add('open');
  rndNT();
}

function ntAdj(d){
  if(ntSelected===null)return;
  let c=Math.max(-100,Math.min(100,(S.offsets[ntSelected]||0)+d));
  S.offsets[ntSelected]=c;
  let val=q('pp-nt-val');if(val)val.textContent=(c>=0?'+':'')+c+'\xa2';
  let sl=q('pp-nt-slider');if(sl)sl.value=c;
  rndNT();save();
}

function ntSlider(v){
  if(ntSelected===null)return;
  let c=parseInt(v);S.offsets[ntSelected]=c;
  let val=q('pp-nt-val');if(val)val.textContent=(c>=0?'+':'')+c+'\xa2';
  rndNT();save();
}

function ntReset(){
  if(ntSelected===null)return;
  S.offsets[ntSelected]=0;
  let val=q('pp-nt-val');if(val)val.textContent='+0\xa2';
  let sl=q('pp-nt-slider');if(sl)sl.value=0;
  rndNT();save();
}

function ntResetAll(){
  if(!confirm('Reset all note tuning to 0\xa2?'))return;
  S.offsets={};ntSelected=null;
  let adj=q('pp-nt-adj');if(adj)adj.classList.remove('open');
  rndNT();save();toast('All notes reset');
}

function rndPerf(){
  let sw=q('pp-psw');if(sw)sw.classList.toggle('on',S.perf);
  let pd=q('pp-d-perf');if(pd)pd.textContent=S.perf?'On':'Off';
  let g=q('pp-pg'),r=q('pp-prst');
  if(g)g.style.display=S.perf?'grid':'none';
  if(r)r.style.display=S.perf?'block':'none';
  if(!S.perf||!g)return;g.innerHTML='';
  BL.forEach((l,i)=>{
    let a=!!(S.mask&(1<<i));
    let b=document.createElement('button');b.textContent=l;b.className=a?'on':'off';
    b.onclick=()=>{S.mask^=(1<<i);rndPerf();ub();save();};
    g.appendChild(b);
  });
}

function togP(){S.perf=!S.perf;rndPerf();ub();save();}
function rstP(){S.mask=0x0FFF;rndPerf();ub();save();}

function rstAll(){
  if(!confirm('Reset all settings to defaults?'))return;
  S={lowestMIDI:65,tunSys:'Equal Temperament',tunRoot:0,rn:'A',ro:4,rf:440,
    bpm:100,mOn:false,mMidi:69,susOn:false,color:'wood',perf:false,mask:0x0FFF,offsets:{}};
  ntSelected=null;save();rndS();uAll();applyColor();
}

function uAll(){
  ub();umk();
  let sw=q('pp-msw');if(sw)sw.classList.toggle('on',S.mOn);
  let mx=q('pp-mx');if(mx)mx.classList.toggle('open',S.mOn);
  let ss=q('pp-ssw');if(ss)ss.classList.toggle('on',S.susOn);
  uSusVis();
  let bn=q('pp-bn');if(bn)bn.textContent=S.bpm;
  umd();
}

// expose globals needed by inline handlers
window.ppTogM=togM;window.ppBpm=bpm;window.ppOpenS=openS;window.ppCloseS=closeS;
window.ppTog=tog;window.ppNr=nr;window.ppSr=sr;window.ppURef=uRef;window.ppApplyT=applyT;
window.ppNtAdj=ntAdj;window.ppNtSlider=ntSlider;window.ppNtReset=ntReset;window.ppNtResetAll=ntResetAll;
window.ppTogP=togP;window.ppRstP=rstP;window.ppRstAll=rstAll;

// Mobile AudioContext unlock, must be triggered by a real user gesture
function unlockAudio() {
    if (!ac) {
        try { ac = new (window.AudioContext || window.webkitAudioContext)({latencyHint:'interactive'}); }
        catch(e) { try { ac = new (window.AudioContext || window.webkitAudioContext)(); } catch(e2) { return; } }
    }
    if (ac.state === 'suspended' || ac.state === 'interrupted') {
        ac.resume().catch(function(){});
    }
    ctSilentOn();
    // Prime with a silent buffer, iOS requires actual audio output
    // to fully unlock, not just creating the context
    try {
        let buffer = ac.createBuffer(1, 1, 22050);
        let source = ac.createBufferSource();
        source.buffer = buffer;
        source.connect(ac.destination);
        source.start(0);
    } catch(e) {}
}

document.addEventListener('DOMContentLoaded',function(){
  load();S.mOn=false;S.susOn=false;
  mkBtns();buildSustainSwitch();buildColorSection();applyColor();uAll();initW();
  // The theme's base-start.css hides every empty <div> (div:empty{display:none}).
  // The toggle knobs have no text, so give them an explicit inline display to
  // keep the sliding knob visible on the Metronome and Sustain switches.
  document.querySelectorAll('#ct-pp .pp-sw .k').forEach(function(k){k.style.display='block';});
  let sov=q('pp-sov');
  if(sov)sov.addEventListener('click',function(e){if(e.target===sov)closeS();});

  // Attach unlock to multiple gesture types at window level
  // (bypasses stopPropagation on button handlers)
  ['touchstart', 'touchend', 'pointerdown', 'mousedown'].forEach(function(evt) {
      window.addEventListener(evt, function unlockOnce() {
          unlockAudio();
          ctSilentOn();
          ['touchstart', 'touchend', 'pointerdown', 'mousedown'].forEach(function(e) {
              window.removeEventListener(e, unlockOnce);
          });
      }, { once: true, passive: true, capture: true });
  });

  // Recover audio after iOS/Safari interruptions (lock screen, phone call,
  // tab switch). The context becomes 'suspended'/'interrupted' and would
  // otherwise only recover on the next tap, resume it when the page returns.
  function resumeCtx(){ if(ac && ac.state!=='running'){ try{ ac.resume(); }catch(e){} } }
  document.addEventListener('visibilitychange',function(){ if(document.hidden){ ctSilentOff(); } else { resumeCtx(); } });
  window.addEventListener('focus',resumeCtx,{passive:true});
  window.addEventListener('pageshow',resumeCtx,{passive:true});
});

})();
